import { html } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';

/**
 * @component {kat-blueprint-workflow} KatBlueprintWorkflow The Workflow Blueprint guides the user through the completion of a task on one or more entities across multiple logical steps, whether the steps are split across multiple screens/pages, or displayed on a single page. The entity(s) may be preselected, or determined as a part of this workflow.
 */
@register('kat-blueprint-workflow')
export class KatBlueprintWorkflow extends KatLitElement {
  render() {
    return html`<slot></slot>`;
  }
}
